import { t } from '~/helpers/localization';

enum ONBOARDING_STEP_TYPES {
  DIALOG = 'dialog',
  GUIDINGTIP = 'guidingtip',
}

export enum ONBOARDING_GUIDES {
  CLANSTARS_REFINED = `clanstars_refined:${ONBOARDING_STEP_TYPES.GUIDINGTIP}`,
  CLAN_ABOUT_DISCORD = `clan_about_discord:${ONBOARDING_STEP_TYPES.GUIDINGTIP}`,
  PATROLS_BONUSES = `patrols_bonuses:${ONBOARDING_STEP_TYPES.GUIDINGTIP}`,
  PATROLS_EVENT = `patrols_event:${ONBOARDING_STEP_TYPES.GUIDINGTIP}`,
  PATROLS_JOIN = `patrols_join:${ONBOARDING_STEP_TYPES.GUIDINGTIP}`,
  PATROLS_REWARDS_UPDATE = `patrols_rewards_update:${ONBOARDING_STEP_TYPES.GUIDINGTIP}`,
  CLANHUB_NAV_NAVAL_BASE = `clanhub_nav_naval_base:${ONBOARDING_STEP_TYPES.GUIDINGTIP}`,
  CLANHUB_NAV_CLAN_MANAGEMENT = `clanhub_nav_clan_management:${ONBOARDING_STEP_TYPES.GUIDINGTIP}`,
  CLANHUB_NAV_ACTIVITIES = `clanhub_nav_activities:${ONBOARDING_STEP_TYPES.GUIDINGTIP}`,
  CLANHUB_NAV_RETURN_TO_CLANHUB = `clanhub_nav_return_to_clanhub:${ONBOARDING_STEP_TYPES.GUIDINGTIP}`,
}

export enum ONBOARDING_DIALOGS {
  CLANSTARS_ROUTE_ENTRY = `clanstars_route_entry:${ONBOARDING_STEP_TYPES.DIALOG}`,
  PATROLS_ROUTE_ENTRY = `patrols_route_entry:${ONBOARDING_STEP_TYPES.DIALOG}`,
}

export const ONBOARDING_GUIDES_CONFIG = {
  CLANHUB_NAV_NAVAL_BASE: {
    name: ONBOARDING_GUIDES.CLANHUB_NAV_NAVAL_BASE,
    header: t('Naval Base'),
    content: t('The Clan Base grants bonuses and benefits. The more developed the Base is, the greater they become.'),
  },
  CLANHUB_NAV_CLAN_MANAGEMENT_RECRUITER: {
    name: ONBOARDING_GUIDES.CLANHUB_NAV_CLAN_MANAGEMENT,
    header: t('Your Clan'),
    content: t(`Manage your Clan's requests and invites, compare your Clan with others, and track missions.`),
  },
  CLANHUB_NAV_CLAN_MANAGEMENT_CAN_HANDLE_INVITES: {
    name: ONBOARDING_GUIDES.CLANHUB_NAV_CLAN_MANAGEMENT,
    header: t('Your Clan'),
    content: t(
      `Manage your Clan's members, requests and invites, allocate resources, compare your Clan with others, and track missions.`,
    ),
  },
  CLANHUB_NAV_CLAN_MANAGEMENT: {
    name: ONBOARDING_GUIDES.CLANHUB_NAV_CLAN_MANAGEMENT,
    header: t('Your Clan'),
    content: t(`View your Clan's members and Treasury, compare your clan with others, and track missions.`),
  },
  CLANHUB_NAV_ACTIVITIES: {
    name: ONBOARDING_GUIDES.CLANHUB_NAV_ACTIVITIES,
    header: t('Activities'),
    content: t(
      'Explore various events and activities where you can fight alongside your Clanmates and earn resources.',
    ),
  },
  CLANHUB_NAV_RETURN_TO_CLANHUB: {
    name: ONBOARDING_GUIDES.CLANHUB_NAV_RETURN_TO_CLANHUB,
    header: t('Return to Clan menu'),
    content: t('Click this button to return to the Clan Menu at any time.'),
  },
  CLANSTARS_REFINED: {
    name: ONBOARDING_GUIDES.CLANSTARS_REFINED,
    header: t('Раздел «Звезда отряда» обновлён'),
    content: t('Посмотрите, что изменилось'),
  },
  CLAN_ABOUT_DISCORD_GUEST: {
    name: ONBOARDING_GUIDES.CLAN_ABOUT_DISCORD,
    header: t('Clan description and bonuses'),
    content: t('Learn more about the Clan and its active bonuses.'),
  },
  CLAN_ABOUT_DISCORD_MEMBER: {
    name: ONBOARDING_GUIDES.CLAN_ABOUT_DISCORD,
    header: t('Discord link'),
    content: t("Add link to your Clan's Discord server."),
  },
  PATROLS_BONUSES: {
    name: ONBOARDING_GUIDES.PATROLS_BONUSES,
    header: t('Earn bonuses and rewards'),
    content: t(
      'You can play either solo or in a Division. Playing in a Division will earn you more bonuses and additional rewards.',
    ),
  },
  PATROLS_JOIN: {
    name: ONBOARDING_GUIDES.PATROLS_JOIN,
    header: t('Join a Patrol'),
    content: t('Choose a battle type, join a Patrol, play, and earn more bonuses.'),
  },
  PATROLS_EVENT: {
    name: ONBOARDING_GUIDES.PATROLS_EVENT,
    header: t('Patrol Update'),
    content: t(
      'The Patrols are updated every 24 hours. You will need to rejoin the Patrols after they have been updated.',
    ),
  },
  PATROLS_REWARDS_UPDATE: {
    name: ONBOARDING_GUIDES.PATROLS_REWARDS_UPDATE,
    header: t('Rewards update'),
    content: t(
      'To receive new rewards, you need to refresh the current ones. Refreshing can be done once a day after the patrols update. Any unclaimed rewards will be lost upon refreshing.',
    ),
  },
} as const;

export const onboardingStepsList = [
  // Routes entries
  ONBOARDING_DIALOGS.CLANSTARS_ROUTE_ENTRY,
  ONBOARDING_DIALOGS.PATROLS_ROUTE_ENTRY,
  // GuidingTips
  ONBOARDING_GUIDES.CLAN_ABOUT_DISCORD,
  // Hub
  ONBOARDING_GUIDES.CLANHUB_NAV_NAVAL_BASE,
  ONBOARDING_GUIDES.CLANHUB_NAV_CLAN_MANAGEMENT,
  ONBOARDING_GUIDES.CLANHUB_NAV_ACTIVITIES,
  ONBOARDING_GUIDES.CLANHUB_NAV_RETURN_TO_CLANHUB,
  // Nav menu guidingtips
  ONBOARDING_GUIDES.CLANSTARS_REFINED,
  // Patrols
  ONBOARDING_GUIDES.PATROLS_BONUSES,
  ONBOARDING_GUIDES.PATROLS_JOIN,
  ONBOARDING_GUIDES.PATROLS_EVENT,
  ONBOARDING_GUIDES.PATROLS_REWARDS_UPDATE,
];
